import { jsx } from "react/jsx-runtime";
import { iconFactory } from "./Icon.js";
const IconArrow = iconFactory('IconArrow', /*#__PURE__*/ jsx("path", {
    "data-icon-type": "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 11.1889L7.39173 13.3102L10.5032 10.2285L10.5032 19.5032L13.5032 19.5032L13.5032 10.2348L16.6083 13.3102L18.75 11.1889L12 4.5032L5.25 11.1889Z"
}));
export { IconArrow };
